import { render, staticRenderFns } from "./ObligationsReportPdf.vue?vue&type=template&id=77582b8a&scoped=true&"
import script from "./ObligationsReportPdf.vue?vue&type=script&lang=js&"
export * from "./ObligationsReportPdf.vue?vue&type=script&lang=js&"
import style0 from "./ObligationsReportPdf.vue?vue&type=style&index=0&id=77582b8a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77582b8a",
  null
  
)

export default component.exports